export default {
  state: () => ({
    windowWidth: 0
  }),

  getters: {
    windowWidth: state => state.windowWidth,
    isMobile: state => state.windowWidth < 768
  },

  mutations: {
    setWindowWidth(state, value) {
      state.windowWidth = value
    }
  },

  actions: {
    setWindowWidth({ commit }, value) {
      commit('setWindowWidth', value)
    }
  }
}
